import { useMemo } from 'react';

import { useFormikContext } from 'formik';
import { useIntl } from 'react-intl';

import { getFiltersConfiguration } from 'app/modules/Devolutions/config';
import useDataTableContext from 'app/components/DataTable/context/DataTableContext';
import { GetSelectStructure } from 'app/hooks/useDevolutionsStatus.hook';

export const useFiltersConfiguration = () => {
  const intl = useIntl();
  const formik = useFormikContext();
  const statusOptions = GetSelectStructure();
  const {
    api: { apiResponse }
  } = useDataTableContext();
  const maxTotal = useMemo(
    () => apiResponse?.meta?.maxTotalAmount || 0,
    [apiResponse?.meta?.maxTotalAmount]
  );

  const completeConfiguration = useMemo(
    () =>
      getFiltersConfiguration({
        intl,
        formik,
        maxTotal,
        statusOptions
      }),
    [formik, intl, maxTotal, statusOptions]
  );

  const getComponentFilter = (targetFilter) =>
    completeConfiguration.find((filter) => filter.value === targetFilter)
      .component;

  const getOptionsToSelect = () =>
    completeConfiguration.map(({ component, ...filter }) => filter);

  return {
    completeConfiguration,
    getComponentFilter,
    getOptionsToSelect
  };
};
